module.exports = __webpack_public_path__ + "img/after1.9ef2c8f4.jpg";